module.exports = __webpack_public_path__ + "img/default_head@2x.862bcfde.png";